<template>
  <div class="pa-connection-list-no-pod">
    <div class="no-pod-message">
      <p class="pa-title">マイポットはありません</p>
      <p class="pa-description">新しいポットを取り寄せてマイポットを作りましょう。</p>
      <p class="pa-description pa-description-mini">(マイポットの作成には「きなこきびだんご」が一つ必要です。)</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
.pa-connection-list-no-pod{
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .no-pod-message{
    margin-top:-3.4rem;
  }

  .pa-title{
    width:80%;
    margin:0 auto;
    color:#A48763;
    font-size:1.4rem;
    line-height:2.4rem;
    text-align: center;
    border-bottom:2px solid #A48763;
  }

  .pa-description{
    text-align:center;
    color:#A48763;
    font-size:.9rem;
    line-height:1;
    margin-top:.5rem;

    &-mini{
      margin-top:.4rem;
      font-size:.7rem;
      line-height: 1rem;
    }
  }
}
</style>